import { render, staticRenderFns } from "./PmAkademi.vue?vue&type=template&id=d26be488&scoped=true&"
import script from "./PmAkademi.vue?vue&type=script&lang=js&"
export * from "./PmAkademi.vue?vue&type=script&lang=js&"
import style0 from "./PmAkademi.vue?vue&type=style&index=0&id=d26be488&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d26be488",
  null
  
)

export default component.exports